<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1"></a>
<p class="title1">A HISTORY OF DEATH IN</p>
<p class="title2"><strong class="b">17TH CENTURY ENGLAND</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half.vue?166fe8df